<template>
  <div class="page__not-found">
    <h1>404</h1>
    <p>{{ $t('page-not-found') }}</p>
  </div>
</template>


<style scoped>
.page__not-found{
  position: absolute;
  top: 20%;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: 100%;
}
h1{
  color: #000000;
  font-size: 60px;
}
p{
  color: #000000;
}
</style>

<script>
export default {
  name: 'page-not-found',
  data: function () {
    return {

    }
  },
  methods: {}
}
</script>

